/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles'

import { Typography, Tooltip, Popover, Paper, Button, Divider, FormControl, FormLabel, FormGroup, FormControlLabel, FormHelperText, Checkbox, CircularProgress } from '@material-ui/core'
import SortIcon from '@material-ui/icons/Sort'
import { Close, DynamicFeed, ListAlt, ArrowDownward, ArrowUpward, LocalOffer, ArrowRightAlt, Filter1 } from '@material-ui/icons'

import Actions from '../../../../fluid/Actions/ActionFactory'
import { getUserPreferences, setUserPreferences } from '../../../UserController/UserPreferences'

const clone = require('rfdc')()
let equal = require('deep-equal')

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
    //   maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
}))(Tooltip);

const default_sort_item = {
    fields : [
      {
        field_name : "order",
        field_source : "operation"
      }
    ],
    direction : "ascending"
}

const styles = theme => ({

})

class SortList extends Component {
    state = {
        open : false,
        anchorEl : null,
        direction_anchor : null,
        field_anchor : null,
        field_context : null,
        show_fields : false,
        applied_sort : null,
        temp_sort : null,
        iu_details : null,
        ic_object : null,
        iu_fields : null,
        loading_ic_object : false
    }

    sortButton = React.createRef()
    fieldButton = React.createRef()

    componentWillMount () {
        console.log("Sort State IC Object : ", this.props.ic_object)
        console.log("Sort Definition : ", this.props.sort_defs)
        let sort_definition = this.props.sort_defs.find(sort => sort.ic_name === this.props.ic_object.ic_name)
        this.setState({...this.state, applied_sort : sort_definition, temp_sort : sort_definition, iu_details : this.getIUAndFieldList()}, () => console.log("Opening Sort State :", this.state))
    }

    applySort = () => {
        let new_sort = clone(this.state.temp_sort)
        this.setState({...this.state, applied_sort : new_sort}, () => {
            this.props.apply_sort(this.state.temp_sort, this.props.ic_object.ic_name)
        })
    }

    isSortSaved = () => {
        let user_preferences = getUserPreferences()
        let saved_sorts = user_preferences.preferences.recommendation.saved_sort_settings
        let saved_sort = saved_sorts.find(sort => sort.ic_name === this.props.ic_object.ic_name)
        if (equal(saved_sort, this.state.applied_sort)) {
            return true
        } else {
            return false
        }
    }

    removeSavedSort = () => {
        let user_preferences = getUserPreferences()
        let saved_sorts = user_preferences.preferences.recommendation.saved_sort_settings
        let saved_sort_index = saved_sorts.findIndex(filter => filter.ic_name === this.props.ic_object.ic_name)
        saved_sorts.splice(saved_sort_index, 1)
        setUserPreferences(user_preferences)
    }

    saveSort = () => {
        let user_preferences = getUserPreferences()
        let saved_sorts = user_preferences.preferences.recommendation.saved_sort_settings
        let saved_sort_ic_index = saved_sorts.findIndex(filter => filter.ic_name === this.props.ic_object.ic_name)
        if (saved_sort_ic_index === -1) {
            saved_sorts.push(this.state.applied_sort)
        } else {
            saved_sorts[saved_sort_ic_index] = this.state.applied_sort
        }
        setUserPreferences(user_preferences)
    }

    getIUAndFieldList = () => {
        let iu_details = []
        let ius = new Set()
        this.props.ic_object.response.result.map(record => {
            ius.add(record.iu_key.user_friendly_name)
        })
        Array.from(ius).forEach(iu => {
            let iu_record = this.props.ic_object.response.result.find(record => record.iu_key.user_friendly_name === iu)
            let iu_detail = {
                name : iu,
                fields : iu_record.raw_fields.fields.map(field => {
                    return {
                        field : field.name,
                        field_source : iu
                    }
                })
            }
            iu_details.push(iu_detail)
        })
        return iu_details
    }

    renderContext = (context) => {
        if (context === "all_results") {
            return (
                <div 
                    style = {{
                        margin : '15px', 
                        display : 'flex', 
                        flexDirection : 'column', 
                        justifyContent : 'center', 
                        alignItems : 'center',
                        padding : '5px'
                    }}
                >
                    <DynamicFeed fontSize = "large" color = "primary"/>
                    <Typography variant = 'caption'>Sorting Results across all Pages</Typography>
                </div>
            )
        } else if (context === "page") {
            return (
                <div 
                style = {{
                    margin : '15px', 
                    display : 'flex', 
                    flexDirection : 'column',
                    justifyContent : 'center', 
                    alignItems : 'center',
                    padding : '5px'
                }}>
                    <ListAlt fontSize = "large" color = "primary"/>
                    <Typography variant = 'caption'>Sorting Results in a Page</Typography>
                </div>
            )
        }
    }

    toggleDirection = (context) => {
        let temp_sort = clone(this.state.temp_sort)
        let cur_direction = temp_sort.sort_definition[context].direction
        if (cur_direction === 'ascending') {
            temp_sort.sort_definition[context].direction = 'descending'
        } else {
            temp_sort.sort_definition[context].direction = 'ascending'
        }

        this.setState({...this.state, temp_sort : temp_sort}, () => console.log("Toggled Direction Sort State : ", this.state))
    }

    renderDirection = (direction, context) => {
        return (
            <Paper
            elevation = {3}
            style = {{
                margin : '15px', 
                display : 'flex', 
                flexDirection : 'column', 
                justifyContent : 'center', 
                alignItems : 'center',
                padding : '10px',
                cursor : "pointer"
            }}
            onClick = {() => this.toggleDirection(context)}
            >
                {direction === 'ascending' ? <ArrowDownward fontSize = "large" color = "primary"/> : <ArrowUpward fontSize = "large" color = "primary"/>}
                <Typography variant = 'caption'>{direction === 'ascending' ? "Ascending" : "Descending"}</Typography>
            </Paper>
        )
    }

    isOpFieldPresent = (field_name, context) => {
        if (this.state.temp_sort !== null) {
            if (this.state.temp_sort.sort_definition[context].fields.findIndex(field => field.field_name === field_name) !== -1) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    handleOpFields = (event, context) => {
        console.log("Sort State toggled OP fields : ", event.target.name, context)
        let new_sort = clone(this.state.temp_sort)
        if (this.isOpFieldPresent(event.target.name, context)) {
            new_sort.sort_definition[context].fields = []
        } else {
            new_sort.sort_definition[context].fields = []
            new_sort.sort_definition[context].fields.push({
                field_name : event.target.name,
                field_source : "operation"
            })
        }
        this.setState({
            ...this.state,
            temp_sort : new_sort
        }, () => console.log("Sort State toggled OP fields : ", this.state))
    }

    renderOpFields = (context) => {
        return (
            <div>
                <Typography style = {{display : 'block'}} variant = 'button'>Operation Fields</Typography>
                <FormControl component="fieldset">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={this.isOpFieldPresent("order", context) ? true : false} 
                                    onChange={(event) => this.handleOpFields(event, context)} 
                                    name="order" 
                                />}
                            label="Rank Order"
                            disabled = {this.state.temp_sort.sort_definition[context].fields.filter(field => field.field_source !== 'operation').length > 0 ? true : false}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={this.isOpFieldPresent("score", context) ? true : false} 
                                    onChange={(event) => this.handleOpFields(event, context)} 
                                    name="score" 
                                />}
                            label="Confidence Score"
                            disabled = {this.state.temp_sort.sort_definition[context].fields.filter(field => field.field_source !== 'operation').length > 0 ? true : false}
                        />
                    </FormGroup>
                    <FormHelperText>If any operation field is selected, all IU fields will be disabled. Uncheck an operation field to enable IU fields.</FormHelperText>
                </FormControl>
            </div>
        )
    }

    getListOfIUs = (ic_object) => {
        let iu_list = new Set()
        ic_object.response.result.map(record => {
            iu_list.add(record.iu_key.user_friendly_name)
        })

        return Array.from(iu_list)
    }

    getRawFields = (iu_name, ic_object) => {
        let fields = new Set()
        let filtered_records = ic_object.response.result.filter(record => record.iu_key.user_friendly_name === iu_name)
        filtered_records.map(record => {
            let raw_fields = record.raw_fields.fields.map(field => field.name)
            raw_fields.map(field => fields.add(field))
        })

        return Array.from(fields)
    }

    getIUFields = () => {
        this.setState({...this.state, loading_ic_object : true}, () => {
            let iu_list = this.getListOfIUs(this.props.ic_object)
            let iu_fields = iu_list.map(iu => {
                let iu_info = {
                    name : iu,
                    fields : this.getRawFields(iu, this.props.ic_object)
                }

                return iu_info
            })

            this.setState({...this.state, loading_ic_object : false, iu_fields : iu_fields, ic_object : this.props.ic_object})
            // Actions('http_request', {
            //     url : "/sainapse/information_channel/" + this.props.ic_name,
            //     method : "get",
            //     data : {}
            // }).then(res => {
            //     let ic_object = res.data.result
            //     let iu_fields = []
            //     ic_object.information_units.map(iu => {
            //         if (iu.config_type === "Trainable") {
            //             let iu_info = {
            //                 name : iu.name,
            //                 fields : []
            //             }
            //             iu.fields_in_scope.map(field => {
            //                 iu_info.fields.push(field.name)
            //             })

            //             iu_fields.push(iu_info)
            //         }
            //     })   
            // })
        })
    }

    isIUPresent = (iu_name, field_name, context) => {
        if (this.state.temp_sort !== null) {
            if (this.state.temp_sort.sort_definition[context].fields.findIndex(field => field.field_source === iu_name) !== -1) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    isIUFieldPresent = (iu_name, field_name, context) => {
        if (this.state.temp_sort !== null) {
            if (this.state.temp_sort.sort_definition[context].fields.findIndex(field => field.field_name === field_name && field.field_source === iu_name) !== -1) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    validateFields = () => {
        let validate = true;
        Object.entries(this.state.temp_sort.sort_definition).forEach((context) => {
            if(context[1] !== null && context[1].fields !== null && context[1].fields.length == 0)
            validate = false;
        })
        return validate;
    }

    handleIUFields = (event, iu_name, context) => {
        console.log("Sort State toggled OP fields : ", event.target.name, context)
        let new_sort = clone(this.state.temp_sort)
        if (this.isIUPresent(iu_name, event.target.name, context)) {
            if (this.isIUFieldPresent(iu_name, event.target.name, context)) {
                let field_index = new_sort.sort_definition[context].fields.findIndex(field => field.name === event.target.name && field.field_source === iu_name)
                new_sort.sort_definition[context].fields.splice(field_index, 1)
            } else {
                let field_index = new_sort.sort_definition[context].fields.findIndex(field =>  field.field_source === iu_name)
                new_sort.sort_definition[context].fields[field_index].field_name = event.target.name
            }
        } else {
            new_sort.sort_definition[context].fields.push({
                field_name : event.target.name,
                field_source : iu_name
            })
        }
        this.setState({
            ...this.state,
            temp_sort : new_sort
        }, () => console.log("Sort State toggled OP fields : ", this.state))
    }

    renderEachIU = (iu_info, context) => {
        return (
            <div style = {{maxHeight : '100%', overflow : 'auto', padding : '5px', marginRight : '5px', borderRight : '1px solid rgba(0,0,0,0.12)'}}>
                <Paper elevation = {0} square style = {{width : '100%', height : '100%', padding : '5px'}}>
                    <FormLabel component="legend">{iu_info.name}</FormLabel>
                    <FormGroup>
                        {iu_info.fields.map(field => {
                            return (
                                <FormControlLabel
                                    control={
                                        <Checkbox 
                                            name = {field} 
                                            checked = {this.isIUFieldPresent(iu_info.name, field, context)}
                                            onChange={(event) => this.handleIUFields(event, iu_info.name, context)} 
                                        />}
                                    label = {field}
                                    disabled = {this.state.temp_sort.sort_definition[context].fields.findIndex(field => field.field_source === "operation") !== -1 ? true : false}
                                />
                            )
                        })}
                    </FormGroup>
                </Paper>
            </div>
        )
    }

    renderIUFieldList = (context) => {
        if (this.state.ic_object === null && this.state.loading_ic_object) {
            return (
                <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <CircularProgress color = "primary"/>
                </div>
            )
        } else if (this.state.ic_object === null && !this.state.loading_ic_object) {
            this.getIUFields()
        } else if (this.state.ic_object !== null && !this.state.loading_ic_object) {
            let iu_lists = this.state.iu_fields.map(iu_info => this.renderEachIU(iu_info, context))
            return iu_lists
        }
    }

    renderIUFields = (context) => {
        return (
            <div style = {{flexGrow : 1, display : 'flex', flexDirection : 'column'}}>
                <Typography variant = "button">Information Units</Typography>
                <div style = {{flexGrow : 1, width : '100%', overflow : 'scroll', display : 'flex', flexDirection : 'row'}}>
                    {this.renderIUFieldList(context)}
                </div>
            </div>
        )
    }

    renderFields = (context) => {
        if (context !== null) {
            return (
                <div style ={{
                    width : '100%',
                    height : '100%',
                    display : 'flex',
                    flexDirection : 'column',
                    padding : '10px',
                    flexGrow : 1,
                    overflow : 'scroll'
                }}>
                    {this.renderOpFields(context)}
                    <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                    {this.renderIUFields(context)}
                </div>
            )
        }
    }

    renderFieldList = () => {
        return (
            <Popover
                id = {"field-list"}
                open = {this.state.show_fields}
                anchorEl={this.state.field_anchor}
                onClose={this.closeFieldList}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps = {{
                    square : true,
                    elevation : 4,
                    style : {
                        margin : 0,
                        padidng : 0
                    }
                }}
            >
                <div style = {{
                    width : '50vw',
                    height : '50vh',
                    display : 'flex',
                    flexDirection : 'column'
                }}>
                    <Paper
                        square
                        elevation = {2}
                        style = {{
                            width : '100%', 
                            height : '50px', 
                            display : 'flex', 
                            flexDirection : 'row',
                            alignItems : 'center',
                            backgroundColor : "#2296f3",
                            padding : '10px'
                        }}
                    >
                        <div style = {{flexGrow : 1, display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            <Typography style = {{color : "#FFFFFF"}} variant = "subtitle2">
                                Available Fields for {this.state.field_context === "all_results" ? "All Records" : "Page Records"}
                            </Typography>
                        </div>
                        <Tooltip title = "Close">
                            <Close style = {{color : "#FFFFFF", cursor : "pointer"}} fontSize = "small" onClick = {this.closeFieldList}/>
                        </Tooltip>
                    </Paper>
                    {this.renderFields(this.state.field_context)}
                </div>
            </Popover>
        )
    }

    closeFieldList = () => {
        this.setState({...this.state, field_anchor : null, show_fields : false, field_context : null})
    }

    openFieldList = (event, context) => {
        this.setState({...this.state, field_anchor : event.currentTarget, show_fields : true, field_context : context}, () => console.log("Sort State Opening Fields: ", this.state))
    }

    renderField = (fields, context) => {
        return (
            <Fragment>
                <HtmlTooltip 
                title = {
                    <div>
                        <div>
                            <div style = {{width  : '100%', padding : '5px', display : 'flex', flexDirection : 'column', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                                <Typography style = {{flexGrow : 1}} variant = 'caption' color = "textSecondary">Sort Applied on fields</Typography>
                            </div>
                            {fields.map(field => {
                                return (
                                    <div style = {{width  : '20vw', padding : '5px', display : 'flex', flexDirection : 'column'}}>
                                        <Typography style = {{flexGrow : 1}} variant = 'body2'>Field : {field.field_name}</Typography>
                                        <Typography variant = 'caption' color = "textSecondary">Source: {field.field_source}</Typography>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                }>
                    <div
                        style = {{margin : '15px'}}
                        ref = {this.fieldButton}
                        onClick = {(event) => this.openFieldList(event, context)}
                    >
                        <Paper
                        elevation = {3}
                        style = {{
                            display : 'flex', 
                            flexDirection : 'column', 
                            justifyContent : 'center', 
                            alignItems : 'center',
                            padding : '10px',
                            cursor : "pointer"
                        }}>
                            <LocalOffer fontSize = "large" color = "primary"/>
                            <Typography variant = 'caption'>Applied on fields</Typography>
                        </Paper>
                    </div>
                </HtmlTooltip>
            </Fragment>
        )
    }

    renderSortDetail = (context, allow_null) => {
        if (this.state.temp_sort !== null) {
            if (this.state.temp_sort.sort_definition[context] !== null) {
                return (
                    <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        {this.renderContext(context)}
                        <ArrowRightAlt fontSize = "large" color = "textSecondary"/>
                        {this.renderField(this.state.temp_sort.sort_definition[context].fields, context)}
                        <ArrowRightAlt fontSize = "large" color = "textSecondary"/>
                        {this.renderDirection(this.state.temp_sort.sort_definition[context].direction, context)}
                        
                    </div>
                )
            } else {
                if (allow_null) {
                    return (
                        <div style = {{width : '100%', flexGorw : 1, display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <Button 
                                color = "primary"
                                size = 'small'
                                onClick = {(event) => {
                                    let new_sort = clone(this.state.temp_sort)
                                    new_sort.sort_definition[context] = default_sort_item
                                    this.setState({...this.state, temp_sort : new_sort})
                                }}
                            >
                                Add Page Sort
                            </Button>
                        </div>
                    )
                } else {
                    return (
                        <div style = {{width : '100%', flexGorw : 1, display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <Typography variant = 'caption' color = "textSecondary">No Sort Applied.</Typography>
                        </div>
                    )
                }
            }
        } else {
            return (
                <div style = {{width : '100%', flexGorw : 1, display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <Typography variant = 'caption' color = "textSecondary">No Sort Applied.</Typography>
                </div>
            )
        }
    }

    renderSortList = () => {
        return (
            <div style = {{
                width : '100%',
                height : '100%',
                display : "flex",
                flexDirection : "column"           
            }}>
                <div style = {{padding : '10px', flexGrow : 1, display : 'flex', flexDirection : 'column'}}>
                    <div>
                        <Typography variant = 'overline'>Sort all results</Typography>
                        <Divider/>
                        <Typography variant = 'caption' color = "textSecondary">Applies the sorting function on all the results.</Typography>
                    </div>
                    <div style = {{width : '100%', flexGrow : 1}}>
                        {this.renderSortDetail("all_results", false)}
                    </div>
                </div>
                <div style = {{padding : '10px', flexGrow : 1, display : 'flex', flexDirection : 'column'}}>
                    <div>
                        <div style = {{width  :'100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            <Typography style = {{flexGrow : 1}} variant = 'overline'>Sort results in a page</Typography>
                            <Button
                                color = "secondary"
                                size = 'small'
                                onClick = {(event) => {
                                    let new_sort = clone(this.state.temp_sort)
                                    new_sort.sort_definition.page = null
                                    this.setState({...this.state, temp_sort : new_sort})
                                }}
                                disabled = {this.state.temp_sort.sort_definition.page === null ? true : false}
                            >
                                Remove
                            </Button>
                        </div>
                        <Divider/>
                        <Typography variant = 'caption' color = "textSecondary">Applies the sorting function only on the records in a single page.</Typography>
                    </div>
                    <div style = {{width : '100%', flexGrow : 1}}>
                        {this.renderSortDetail("page", true)}
                    </div>
                </div>
                {this.renderFieldList()}
            </div>
        )
    }

    closePopover = () => {
        this.setState({...this.state, open : false, anchorEl : null})
    }

    openPopover = (event) => {
        this.setState({...this.state, open : true, anchorEl : event.currentTarget}, () => console.log("Sort State : ", this.state))
    }

    renderSortPopover = () => {
        return (
            <Popover
                id = {"sort_list"}
                open = {this.state.open}
                anchorEl={this.state.anchorEl}
                onClose={this.closePopover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps = {{
                    square : true,
                    elevation : 8,
                    style : {
                        margin : 0,
                        padidng : 0
                    }
                }}
            >
                <div style = {{
                    width : '50vw',
                    height : '50vh',
                    display : 'flex',
                    flexDirection : 'column'
                }}>
                    <Paper 
                    square
                    elevation = {2}
                    style = {{
                        width : '100%', 
                        height : '50px', 
                        display : 'flex', 
                        flexDirection : 'row',
                        alignItems : 'center',
                        backgroundColor : "#2296f3",
                        padding : '10px'
                    }}>
                        <div style = {{flexGrow : 1, display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            <SortIcon 
                                style = {{
                                    color : "#FFFFFF",
                                    marginRight : '5px'
                                }} 
                                size = "small"
                            />
                            <Typography style = {{color : "#FFFFFF"}} variant = "subtitle2">Sort Settings</Typography>
                        </div>
                        <Tooltip title = "Close">
                            <Close style = {{color : "#FFFFFF", cursor : "pointer"}} fontSize = "small" onClick = {this.closePopover}/>
                        </Tooltip>
                    </Paper>
                    <div style = {{width : '100%', flexGrow : 1}}>
                        {this.renderSortList()}
                    </div>
                    <div 
                    style = {{
                        width : '100%', 
                        height : '50px', 
                        display : 'flex', 
                        flexDirection : 'row-reverse', 
                        alignItems : 'center', 
                        borderTop : '1px solid rgba(0,0,0,0.12)'
                    }}
                    >
                        <Button 
                            style = {{marginRight : '10px'}} 
                            color = "primary" 
                            size = "small"
                            disabled = {equal(this.state.applied_sort, this.state.temp_sort) || !this.validateFields()}
                            onClick = {this.applySort}
                        >Apply Sort</Button>
                        {this.isSortSaved() ? 
                            <Tooltip title = "Remove this sort setting for this IC. This setting will not be auto applied in the future.">
                                <Button 
                                    color = "secondary" 
                                    size = "small"
                                    disabled = {!equal(this.state.applied_filter, this.state.temp_filter)}
                                    onClick = {this.removeSavedSort}
                                >Do Not Apply in the future</Button>
                            </Tooltip>
                            :
                            <Tooltip title = "Saves this sort setting for this IC and auto applis while querying this IC in the future.">
                                <Button 
                                    color = "primary" 
                                    size = "small"
                                    disabled = {!equal(this.state.applied_filter, this.state.temp_filter)}
                                    onClick = {this.saveSort}
                                >Auto Apply in the future</Button>
                            </Tooltip>
                        }
                        {
                            this.validateFields() ? null: <Typography style = {{marginRight: '10px', color : '#F50157'}} variant = 'caption'>atleast one field has to be selected for sorting</Typography>
                        }
                    </div>
                </div>
            </Popover>
        )
    }

    renderSortShorthand = (context, sort) => {
        if (sort) {
            return (
                <Paper 
                    elevation = {0} 
                    key = {context} 
                    style = {{
                        marginRight : '3px', 
                        padding : '2px', 
                        display : 'flex', 
                        flexDirection : 'row', 
                        alignItems : 'center',
                        backgroundColor : this.state.open ? "#FFFFFF" : "#2296f3" 
                    }}>
                    <div style = {{margin : '3px'}}>
                        {context === "all_results" ? <Tooltip title = "Results Across All Pages">
                            <DynamicFeed style = {{color : this.state.open ? "#2296f3" : "#FFFFFF" }} fontSize = "small"/>
                        </Tooltip> : 
                        <Tooltip title = "Results in a Page">
                            <ListAlt style = {{color : this.state.open ? "#2296f3" : "#FFFFFF" }}  fontSize = "small"/>
                        </Tooltip>}
                    </div>
                    <div style = {{margin : '3px'}}>
                        <HtmlTooltip 
                        title = {
                            <div>
                                <div style = {{width  : '10vw'}}>
                                    <div style = {{width  : '100%', padding : '5px', display : 'flex', flexDirection : 'column', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                                        <Typography variant = 'caption' color = "textSecondary">Sort Applied on Fields</Typography>
                                    </div>
                                    {sort.fields.map(field => {
                                        return (
                                            <div style = {{width  : '100%', padding : '5px', display : 'flex', flexDirection : 'column'}}>
                                                <Typography style = {{flexGrow : 1}} variant = 'body2'>Field: {field.field_name}</Typography>
                                                <Typography variant = 'caption' color = "textSecondary">Source: {field.field_source}</Typography>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        }>
                            <LocalOffer style = {{color : this.state.open ? "#2296f3" : "#FFFFFF" }}  fontSize = "small"/>
                        </HtmlTooltip>
                    </div>
                    <div style = {{margin : '3px'}}>
                        {sort.direction === "ascending" ? 
                        <Tooltip title = "Ascending">
                            <ArrowDownward style = {{color : this.state.open ? "#2296f3" : "#FFFFFF" }}  fontSize = "small"/>
                        </Tooltip> : 
                        <Tooltip title = "Descending">
                            <ArrowUpward style = {{color : this.state.open ? "#2296f3" : "#FFFFFF" }}  fontSize = "small"/>
                        </Tooltip>}
                    </div>
                </Paper>
            )
        }
    }

    render() { 
        const { classes } = this.props
        return (
            <Fragment>
                <div
                    ref = {this.sortButton}
                    onClick = {this.openPopover}
                    style = {{
                        width : '100%', 
                        height : '100%',
                        padding : '5px',
                        display : 'flex',
                        flexDirection : 'row',
                        alignItems : 'center',
                        cursor: 'pointer',
                        backgroundColor : this.state.open ? "#2296f3" : null
                    }}
                >
                    <div style = {{
                        flexGrow : 1,
                        display : 'flex',
                        flexDirection : 'row',
                        alignItems : 'center'
                    }}>
                        <Tooltip title = "Sort">
                            <SortIcon 
                                style = {{
                                    color : this.state.open ? "#FFFFFF" : "rgba(0,0,0,0.75)"
                                }} 
                                size = "small"
                            />
                        </Tooltip>
                        <Typography style = {{margin : '5px', color : this.state.open ? "#FFFFFF" : "rgba(0,0,0,0.8)"}} variant = 'subtitle2'>Sort</Typography>
                    </div>
                    <div 
                        style = {{
                            flexGrow : 1,
                            display : 'flex',
                            flexDirection : 'row',
                            alignItems : 'center',
                            justifyContent : 'flex-end'
                        }}
                    >
                        {this.renderSortShorthand("all_results", this.state.applied_sort.sort_definition.all_results)}
                        {this.renderSortShorthand("page", this.state.applied_sort.sort_definition.page)}
                    </div>
                </div>
                {this.renderSortPopover()}
            </Fragment>
        );
    }
}
 
export default withStyles(styles)(SortList);